import authAxios from "../common/authAxios";

class CenterKatoService {
    async getRegions() {
        return await authAxios.get('/kato/region');
    }
}

export default CenterKatoService;